import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { DocumentUploadRequest } from "../models/request/documentUploadRequest";
import { DocumentTypeDetail } from "../models/response/documentType";
import {
  DocumentUploadResponse,
  RetrieveBankDetailResponse,
  RetrieveUserDocumentResponse,
} from "../models/response";
import { UserDocumentInsertRequest } from "../models/request/userDocumentInsertRequest";
import { RetrieveUserBankAccountResponse } from "../models/response/retrieveUserBankAccountResponse";
import { BankPersistRequest } from "../models/request/bankPersistRequest";

const verificationApi = {
  getDocumentTypes: async (): Promise<UnifiedResponse<DocumentTypeDetail>> => {
    var response = await apiClient.post("/master_proof/retrieve_dropdown", {
      isActive: false,
    });
    return response.data;
  },

  retrieveUserDocument: async (): Promise<
    UnifiedResponse<RetrieveUserDocumentResponse>
  > => {
    var response = await apiClient.get("/user_proof/retrieve");
    return response.data;
  },

  uploadFrontDocument: async (
    data: DocumentUploadRequest
  ): Promise<UnifiedResponse<DocumentUploadResponse>> => {
    var response = await apiClient.post(
      "user_proof/frontend/document/upload",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  uploadBackDocument: async (
    data: DocumentUploadRequest
  ): Promise<UnifiedResponse<DocumentUploadResponse>> => {
    var response = await apiClient.post(
      "user_proof/backend/document/upload",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  userDocumentInsert: async (
    data: UserDocumentInsertRequest
  ): Promise<UnifiedResponse<any>> => {
    var response = await apiClient.post("user_proof/insert", data);
    return response.data;
  },

  retrieveBankAccounts: async (): Promise<
    UnifiedResponse<RetrieveUserBankAccountResponse>
  > => {
    var response = await apiClient.get("/user_bank/retrieve/list");
    return response.data;
  },

  retrieveBankDropdown: async (
    isActive: boolean
  ): Promise<UnifiedResponse<RetrieveBankDetailResponse>> => {
    const response = await apiClient.post(
      "/payment/banks/retrieve_dropdown",
      isActive
    );

    return response.data;
  },

  uploadBankDocument: async (data: DocumentUploadRequest): Promise<UnifiedResponse<any>> => {
    var response = await apiClient.post("/user_bank/attacment/upload",
      data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  persistBankAccount: async (data: BankPersistRequest): Promise<UnifiedResponse<any>> => {
    var response = await apiClient.post("/user_bank/persist", data);
    return response.data;
  },

  deleteBankAccount: async (id: string): Promise<UnifiedResponse<any>> => {
    var response = await apiClient.post(`/user_bank/delete/`, {
      id,
    });
    return response.data;
  },
};

export default verificationApi;
